// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CZot","col":"styles_col__2qm-K"};